export default __webpack_public_path__ + "static/MK_logo_CMYK-ca619f3c7dd8ea762c44d1c89b4b132f.jpg";